var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Media / Icons / Arrows / Chevron-Mini-Down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10 13C9.82984 12.9991 9.662 12.9604 9.50867 12.8866C9.35534 12.8128 9.22035 12.7058 9.11351 12.5733L6.30739 9.17333C6.14341 8.96865 6.04023 8.722 6.00959 8.46151C5.97895 8.20102 6.02209 7.93716 6.13409 7.7C6.22492 7.49388 6.37315 7.31828 6.56108 7.19415C6.74901 7.07002 6.96869 7.00262 7.19388 7H12.8061C13.0313 7.00262 13.251 7.07002 13.4389 7.19415C13.6268 7.31828 13.7751 7.49388 13.8659 7.7C13.9779 7.93716 14.0211 8.20102 13.9904 8.46151C13.9598 8.722 13.8566 8.96865 13.6926 9.17333L10.8865 12.5733C10.7796 12.7058 10.6447 12.8128 10.4913 12.8866C10.338 12.9604 10.1702 12.9991 10 13Z",
    fill: "#737373"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.8169eb54cffb6cde5709e9f81493746c.svg";
export { ForwardRef as ReactComponent };